<template>
  <div class="noni_scartchcard">
    <transition name="fade">
      <!-- The Modal -->
      <div id="myModal" class="modal" v-if="modal">
        <!-- Modal content -->
        <div class="modal-content">
          <div style="padding: 20px">
            <span class="close" @click="modal = !modal">&times;</span>
            <h2 style="text-align: center">Finding Your Amazon Profile Link</h2>
          </div>

          <div>
            <p>
              Your Amazon Profile Page is where you as a user can share
              information about yourself, your personal tastes, and opinions
              regarding various products and services.
            </p>
            <p>
              This page is open to the public. By default it will not disclose
              any personal account information other than your user name.
            </p>
            <p>
              Follow the instructions below to find the link to your Amazon
              Profile Page:
            </p>

            <p>1. Log in to your Amazon account.</p>
            <p>
              2. From the drop down menu of Your Account, click on Your Account.
              <img
                class="alignnone size-full wp-image-13906"
                :src="
                  plugin_dir_url +
                  '../public/images/Finding-Amazon-Review-Permalink1.jpg'
                "
                alt=""
                width="1000"
                height="480"
              />
            </p>
            <p>
              3. In Your Account page, select your Personal Profile image icon.
              <img
                class="alignnone size-full wp-image-13905"
                :src="
                  plugin_dir_url +
                  '../public/images/Finding-Amazon-Review-Permalink-2.jpg'
                "
                alt=""
                width="1000"
                height="480"
              />
            </p>
            <p>
              4. Once in your Profile page, copy the link (url) from your
              internet browser to share your Amazon Profile page.
              <img
                class="alignnone size-full wp-image-13905"
                :src="
                  plugin_dir_url +
                  '../public/images/Finding-Amazon-Review-Permalink-2.jpg'
                "
                alt=""
                width="1000"
                height="480"
              />
            </p>

            <div class="clear"></div>

            <p class="noni-center">
              <button
                class="noni-vip-submit btn primary btn-lg"
                @click="modal = !modal"
              >
                Close
              </button>
            </p>
          </div>
        </div>
      </div>
    </transition>

    <form
      id="noni_vip_form"
      action="<?php admin_url('admin-ajax.php') ?>"
      class="noni_gift_form"
      method="post"
      @submit.prevent
      v-show="!sent"
    >
      <p v-if="country_selection">
        <label>
          {{ country_label }}* <br />
          <select
            class="select-css"
            v-model="form.country"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="country"
          >
            <option
              :value="country.code"
              v-for="country in countries"
              :key="country.code"
            >
              {{ country.name }}
            </option>
          </select>
          <span :class="{ invalid: errors.has('country') }" class="danger">{{
            errors.first("country")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ first_name_label }}* <br />
          <input
            v-model="form.first_name"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="first_name"
          />
          <span :class="{ invalid: errors.has('first_name') }" class="danger">{{
            errors.first("first_name")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ last_name_label }}* <br />
          <input
            v-model="form.last_name"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="last_name"
          />
          <span :class="{ invalid: errors.has('last_name') }" class="danger">{{
            errors.first("last_name")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ email_label }}* <br />
          <input
            v-model="form.email"
            v-validate="'required|email'"
            data-vv-validate-on="blur"
            type="email"
            name="email"
          />
          <span :class="{ invalid: errors.has('email') }" class="danger">{{
            errors.first("email")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ phone_label }}* <br />
          <select
            id="cell-area"
            v-model="form.area_code"
            name="countryCode"
            class="select-css"
          >
            <option
              :value="country.dial_code"
              v-for="country in countries"
              :key="country.code"
            >
              {{ country.name }} {{ country.dial_code }}
            </option>
          </select>
          <input
            id="cell-main"
            v-model="form.phone"
            v-validate="'required|integer'"
            data-vv-validate-on="blur"
            name="phone"
            type="text"
          />
          <span :class="{ invalid: errors.has('phone') }" class="danger">{{
            errors.first("phone")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ profile_link_label }}* <br />
          <input
            v-model="form.profile_link"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="profile_link"
            type="text"
          />

          <span
            :class="{ invalid: errors.has('profile_link') }"
            class="danger"
            >{{ errors.first("profile_link") }}</span
          >
          <br /><span style="font-size: 0.8em"
            ><a @click="modal = !modal" href="javascript:void(0)">Click here</a>
            if you're not sure how to find your profile link.</span
          >
        </label>
      </p>
      <p class="noni-center">
        <button
          class="noni-scratchcard-submit btn primary btn-lg"
          @click="send()"
          :disabled="loading"
        >
          <span v-if="loading"> Sending </span>
          <span v-else> Send </span>
        </button>
      </p>
    </form>

    <div v-show="sent" class="noni-message" ref="message">
      <h3>Registration Complete!</h3>
    </div>
  </div>
</template>

<script>
var Qs = require("qs");
import Swal from "sweetalert2";
import CONSTANTS from "../constants";
export default {
  name: "VipForm",
  data: () => ({
    loading: false,
    form: {
      ajax_nonce: window.ajax_object.ajax_nonce,
      email: "",
      first_name: "",
      last_name: "",
      phone: "",
      action: "vip_form_submission",
      area_code: "+1",
      country: "US",
      profile_link: "",
    },
    country_selection: true,
    sent: false,
    countries: CONSTANTS.COUNTRIES,
    email_label: "Email",
    first_name_label: "First Name",
    last_name_label: "Last Name",
    phone_label: "Phone Number",
    profile_link_label: "Amazon Profile Link",
    country_label: "Country",
    top_message: "",
    modal: false,

    top_message_de: `Wir sind auf der Suche nach neuen Ideen, echten Meinungen und Ihren Gedanken zu unserer aktuellen ${window.ajax_object.app_name} Produktlinie und neue Produkte! Mit Ihrer Perspektive werden wir weiterhin in der Lage sein, nur die besten Produkte, Dienstleistungen und Erfahrungen zu verbessern und zu liefern, die wir können!`,
    top_message_en: `We’re looking for fresh ideas, real opinions and your thoughts about what you think of our current ${window.ajax_object.app_name} products line and new products! With your perspective, we’ll be able to continue improving and delivering only the best products, services and experience we can!`,
  }),
  watch: {
    "form.country": function (val) {
      if (val == "DE") {
        this.setGerman();
      } else {
        this.setEnglish();
      }
    },
  },
  computed: {
    // a computed getter
    plugin_dir_url: function () {
      // `this` points to the vm instance
      return window.ajax_object.plugin_dir_url;
    },
  },
  mounted: function () {
    this.top_message = this.top_message_en;

    this.axios
      .get(
        "https://api.ipdata.co?api-key=05ac003d8a8be6675badabe27f1e726c6925a6ffb611ce0abcf2f7db"
      )
      .then((response) => {
        this.form.country = response.data.country_code;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    setEnglish() {
      this.$validator.localize("en", {
        attributes: {
          email: "Email",
          first_name: "First Name",
          last_name: "Last Name",
          phone: "Phone Number",
          profile_link: "Profile Link",
          country: "Country",
        },
      });
      this.email_label = "Email";
      this.first_name_label = "First Name";
      this.last_name_label = "Last Name";
      this.phone_label = "Phone Number";
      this.profile_link_label = "Amazon Profile Link";
      this.country_label = "Country";
      this.top_message = this.top_message_en;
    },
    setGerman() {
      this.$validator.localize("de", {
        attributes: {
          email: "E-Mail-Adresse",
          first_name: "Vorname",
          last_name: "Nachname",
          phone: "Telefonnummer",
          profile_link: "Profile Link",
          country: "Land",
        },
      });
      this.email_label = "E-Mail-Adresse";
      this.first_name_label = "Vorname";
      this.last_name_label = "Nachname";
      this.phone_label = "Telefonnummer";
      this.profile_link_label = "Profile Link";
      this.country_label = "Land";
      this.top_message = this.top_message_de;
    },
    send() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true;

          this.form.phone = this.form.area_code + this.form.phone;

          this.axios
            .post(window.ajax_object.ajax_url, Qs.stringify(this.form))
            .then((response) => {
              if (response.data.success == true) {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  type: "success",
                });

                this.sent = true;

                var element = this.$refs["message"];
                var top = element.offsetTop;
                window.scrollTo(0, top);
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.data.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          Swal.fire({
            title: "Error",
            text: "The form is invalid",
            type: "error",
          });
        }
      });
    },
  },
};
</script>
